import { useEffect, useState } from "react";
import { afterPageLoad } from "@/lib/after-page-load";

// Cuenta total de "usuarios" de la plataforma = cuentas de acceso (auth.users)
// + tutores + niños, vía la RPC pública `get_platform_user_count`. Se usa como
// prueba social en landing / footer / contacto. Se refresca cada 60s para que
// la cifra se sienta viva. Devuelve null hasta la primera respuesta.
//
// LDT-718 · Con fetch y la clave publicable, no con el cliente de Supabase: es
// la única llamada que hace la portada al cargar, y el cliente (auth, realtime,
// storage) eran ~60 KB comprimidos solo para esto. La RPC es pública (anon; ver
// src/test/rpc-privileges.test.ts), igual que las llamadas a billing-checkout
// de CheckoutModal. Y la primera consulta espera a que la portada haya
// cargado: la cifra no puede frenar lo que se pinta.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

export function usePlatformUserCount(): number | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let active = true;
    const fetchCount = async () => {
      try {
        const res = await fetch(`${SUPABASE_URL}/rest/v1/rpc/get_platform_user_count`, {
          method: "POST",
          headers: { "Content-Type": "application/json", apikey: SUPABASE_PUBLISHABLE_KEY },
          body: "{}",
        });
        if (!res.ok) return;
        const data = await res.json();
        if (active && data != null) setCount(Number(data));
      } catch {
        // Sin red o sin respuesta: la cifra simplemente no se muestra.
      }
    };
    void afterPageLoad().then(() => active && fetchCount());
    const id = setInterval(fetchCount, 60_000);
    return () => {
      active = false;
      clearInterval(id);
    };
  }, []);

  return count;
}
